import React from "react";
import moment from "moment";
import I18n from "i18n-js";

const formatDate = (date) => {
  const offsetDate = moment.utc(date).local().toDate();
  return I18n.l("date.formats.default", offsetDate);
}

const TaskHistoryItem = ({ item }) => (
  <div className="task-history-item">
    <span className="title">{item.title}</span>
    <span className="content">{item.content}</span>
    <span className="date">{formatDate(item.created_at)}</span>
  </div>
);

export default TaskHistoryItem;
